import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from 'src/components/button/button.component';
import { IconModule } from 'src/components/icon/icon.module';
import { InputNumberComponent } from 'src/components/input/input-number.component';
import { InputPhoneExtComponent } from 'src/components/input/input-phone-ext.component';
import { InputRadioComponent, InputRadioOption } from 'src/components/input/input-radio.component';
import { InputTextComponent } from 'src/components/input/input-text.component';
import { Form, FormError } from 'src/definitions/form.definition';
import { CreateKaryawanForm, GenderType } from 'src/definitions/karyawan.definition';
import { FormService } from 'src/services/form.service';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';
import { InputImageComponent } from 'src/components/input/input-image.component';

export type FamilyForm = Pick<CreateKaryawanForm, 'kk_number' | 'kk_image' | 'keluarga'>;

@Component({
  selector: 'step-5',
  templateUrl: './step-5.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    ButtonComponent,
    InputTextComponent,
    InputImageComponent,
    InputRadioComponent,
    InputNumberComponent,
    InputPhoneExtComponent,
  ],
})
export class _Step5Component {
  @Input()
  set form(value: Form<FamilyForm>) {
    this.__form = value;
    setTimeout(() => {
      (value.value.keluarga ?? []).forEach((val) => {
        this.relationSelected.push(val.relation ?? '');
      });
    });
  }
  get form() {
    return this.__form;
  }

  private __form!: Form<FamilyForm>;

  @Input()
  formError!: FormError<FamilyForm>;

  @Output()
  next = new EventEmitter<void>();

  @Output()
  back = new EventEmitter<void>();

  @Output()
  add = new EventEmitter<void>();

  @Output()
  remove = new EventEmitter<number>();

  protected relationOption: InputRadioOption = [
    { label: 'Istri', value: 'Istri' },
    { label: 'Suami', value: 'Suami' },
    { label: 'Anak', value: 'Anak' },
    { label: 'Ibu', value: 'Ibu' },
    { label: 'Ayah', value: 'Ayah' },
    { label: 'Lainnya', value: 'Lainnya' },
  ];

  protected genderOption: InputRadioOption = [
    { label: 'Laki-laki', value: GenderType.LakiLaki },
    { label: 'Perempuan', value: GenderType.Perempuan },
  ];

  protected relationSelected: string[] = [];

  constructor(
    private toastService: ToastService,
    protected globalService: GlobalService,
    protected formService: FormService,
  ) {}

  protected _remove(index: number) {
    this.relationSelected.splice(index, 1);
    this.remove.emit(index);
  }

  protected _changeRelation(relation: string, index: number) {
    this.relationSelected[index] = relation;
    this.form.controls.keluarga.controls[index].controls.relation.setValue('');

    if (relation !== 'Lainnya') {
      this.formService.resetError(this.formError.keluarga[index], 'relation');
      this.form.controls.keluarga.controls[index].controls.relation.setValue(relation);
    }
  }

  protected _next() {
    if (this.form.invalid) {
      const invalid = this.formService.validateAndGetErrorMessage(this.form, this.formError);
      this.toastService.showToast({
        summary: invalid,
        detail: 'Cek ulang isian',
        severity: 'error',
      });
      return;
    }

    this.next.emit();
  }
}
